<div class="row">
    <div class="col-md-12 section-title text-center">
        <h4>Securing Financial Mobile Apps with Mobile RASP</h4>
    </div>
</div>
<div class="container">
    <div class="row">
        <div class="col-md-1"></div>
        <div class="col-md-10 text-center">
            <video [src]="videoUrl" controls type="video/mp4" autoplay></video>
            <!-- <video [src]="videoUrl" controls width="750" height="390" type="video/mp4" autoplay></video> -->
        </div>
        <div class="col-md-1"></div>
    </div>
</div>